import { useBrandedResource } from './useBrandedResource';
import { ResourceName } from 'config/resources/resourceNames';

export const useBrandSignUpLink = () =>
  useBrandedResource(ResourceName.SIGN_UP_LINK);
